import React, {Component} from 'react';
import style from '../css/openBetRacing.css';
import {connect} from 'react-redux';
import {getGameTitle} from '../../../../../helpers/eventHelpers';
import {
    FORECAST,
    PLACE,
    REVERSE_FORECAST,
    REVERSE_TRICAST,
    SHOW,
    TO_WIN,
    TO_WIN_EW,
    TRICAST
} from '../constants/identifiers';
import OpenBet from '../../../components/openBet';
import {getOdd} from '../helpers/betFunctions';
import {getFormattedCurrency, getText} from '../../../../../helpers/localization';
import CheckBox from '../../../components/checkBox'
import {toggleEwBet} from '../../../actions/openBetsActions'
import {calculateEachWayValues, getDefaultEachWayString} from '../../../../../helpers/eachWayBetHelpers';
import {isDogsEvent, isMarbleEuroEvent, isMarbleEvent, isMarbleNonEuroEvent} from "../helpers/racersHelper";
import {isEnabledMarket} from "../../../helpers/betHelpers";

const mapStateToProps = (state, ownProps) => {
    return {
        betsCommitting: state.vpp.betsCommitting,
        games: state.vpp.games,
        disabledMarkets: state.vpp.disabledMarkets
    };
};


class OpenBetRacing extends Component {

    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            betsCommitting: storeData.vpp.betsCommitting,
            games: storeData.vpp.games,
            disabledMarkets: storeData.vpp.disabledMarkets
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                betsCommitting: storeData.vpp.betsCommitting,
                games: storeData.vpp.games,
                disabledMarkets: storeData.vpp.disabledMarkets
            });
        }
    }

    render() {
        let currentBet = this.props.betSelection.bets[0];
        let gameName = currentBet.game.name;
        let racersList = currentBet.racers;
        let racersNamesList = racersList.map((racer, index) => {
            let prefix = '';
            switch (currentBet.betType.name) {
                case TO_WIN.name:
                case PLACE.name:
                case SHOW.name:
                case FORECAST.name:
                case REVERSE_FORECAST.name:
                case TRICAST.name:
                case REVERSE_TRICAST.name:
                    if (isMarbleNonEuroEvent(currentBet.event.eventType, gameName)) {
                        prefix = getText('MARBLE', this.props.store) + ' ' + racer.num;
                    } else {
                        prefix = racer.num + '. ';
                    }
                    break;
                default:
                    prefix = '';
            }
            let racerName = isMarbleEuroEvent(currentBet.event.eventType, gameName) ? getText(gameName + "_" + racer.num, this.props.store) : racer.name;
            return (prefix + racerName);
        });


        let betType;
        let odd;

        odd = getOdd(this.props.betSelection);
        // betType = getBetTypeText(this.props.betSelection, this.props.store);

        let eventName = getGameTitle(getText(currentBet.event.title, this.props.store), currentBet.event.eventTimeDate, this.props.store.getState().vpp.systemLanguage);

        // let marketNum = currentBet.market.num;
        let silks;
        // let silks = marketNum.toString().split('-');

        let eachWayCheckBox;
        let eachWayText;
        let potentialReturns;

        let showEachWay = isEnabledMarket(this.state, this.props.disabledMarkets, this.props.betSelection.bets[0].game.channel, TO_WIN_EW.name);

        switch (currentBet.betType.name) {
            case TO_WIN.name:
                betType = getText('WIN', this.props.store);
                let isEachWayChecked;
                if (currentBet.externalRefId === undefined) {
                    isEachWayChecked = false;
                } else {
                    isEachWayChecked = true;

                    let ewValues = calculateEachWayValues(this.props.betSelection.stake, odd, currentBet.event.eachWayRatio);
                    potentialReturns = getFormattedCurrency(this.props.store, ewValues.potentialReturns, 2);
                    potentialReturns =  (potentialReturns && typeof potentialReturns === 'string' && potentialReturns.includes(String.fromCharCode(165))) ? potentialReturns.replace(String.fromCharCode(165), '') : potentialReturns;

                }

                // only shows EW on races that have Place bet type (for example, speedway don't have it)
                if (showEachWay && !isMarbleEvent(currentBet.event.eventType)) {
                    eachWayCheckBox = (<CheckBox style={style.checkBox} isChecked={isEachWayChecked}
                                                 isEnabled={!this.state.betsCommitting}
                                                 callback={() => this.props.store.dispatch(toggleEwBet(this.props.betSelection))}/>);
                }
                break;
            // case PLACE:
            //   betType = getText(TO_WIN.name, this.props.store);
            //   eachWayCheckBox = (<CheckBox style={style.checkBox} isChecked={true} isEnabled={true} callback={() => this.props.store.dispatch(toggleEwBet(this.props.betSelection))}/>);;
            //   break;
            // case SHOW:
            //   betType = getText(TO_WIN.name, this.props.store);
            //   eachWayCheckBox = <CheckBox style={style.checkBox} isChecked={true} isEnabled={true} callback={() => this.props.store.dispatch(toggleEwBet(this.props.betSelection))}/>
            //   break;
            case PLACE.name:
                betType = getText(PLACE.name, this.props.store);
                break;
            case SHOW.name:
                betType = getText(SHOW.name, this.props.store);
                break;
            case FORECAST.name:
                if (isMarbleEvent(currentBet.event.eventType)) {
                    betType = getText('FORECAST_MARBLE', this.props.store);
                } else {
                    betType = getText(FORECAST.name, this.props.store);
                }
                break;
            case REVERSE_FORECAST.name:
                if (isMarbleEvent(currentBet.event.eventType)) {
                    betType = getText('REVERSE_FORECAST_MARBLE', this.props.store);
                } else {
                    betType = getText(REVERSE_FORECAST.name, this.props.store);
                }
                // silks = silks.sort((a, b) => a - b);
                break;
            case TRICAST.name:
                if (isMarbleEvent(currentBet.event.eventType)) {
                    betType = getText('TRICAST_MARBLE', this.props.store);
                } else {
                    betType = getText(TRICAST.name, this.props.store);
                }
                break;
            case REVERSE_TRICAST.name:
                if (isMarbleEvent(currentBet.event.eventType)) {
                    betType = getText('REVERSE_TRICAST_MARBLE', this.props.store);
                } else {
                    betType = getText(REVERSE_TRICAST.name, this.props.store);
                }
                // silks = silks.sort((a, b) => a - b);
                break;
            default:
                break;
        }
        if (showEachWay) {
            switch (currentBet.betType.name) {
                case TO_WIN.name:
                    if (!isDogsEvent(currentBet.event.eventType)) {
                        const eachWayRatio = currentBet.event.eachWayRatio;
                        eachWayText = (<div
                            className={style.eachWayText}>{getText('EACH_WAY_ODDS_SHOW', this.props.store, [eachWayRatio === undefined ? getDefaultEachWayString() : eachWayRatio])}</div>);
                    } else {
                        const eachWayRatio = currentBet.event.eachWayRatio;
                        eachWayText = (<div
                            className={style.eachWayText}>{getText('EACH_WAY_ODDS_PLACE', this.props.store, [eachWayRatio === undefined ? getDefaultEachWayString() : eachWayRatio])}</div>);
                    }
                    break;
                default:
            }
        }

        let eachWayCheckBoxUI;
        if (eachWayCheckBox !== undefined && eachWayText !== undefined) {
            eachWayCheckBoxUI = (<div className={style.eachWayContainer}>{eachWayCheckBox}{eachWayText}</div>)
        }
        return (<OpenBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                         names={racersNamesList} silks={silks} betType={betType} odd={odd}
                         potentialReturns={potentialReturns} eventName={eventName} checkBox={eachWayCheckBoxUI}
                         openBetFocusCallback={this.props.openBetFocusCallback} isEnabled={this.props.isEnabled}/>);
    }
}

export default connect(mapStateToProps)(OpenBetRacing);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/components/openBetRacing.js